import { BookOpen, Languages, Calculator, Leaf, FlaskConical, Globe2, BookText } from "lucide-react";

const ICONS = {
    Odia: BookText,
    English: Languages,
    Mathematics: Calculator,
    EVS: Leaf,
    Science: FlaskConical,
    "Social Science": Globe2,
};

const COLORS = {
    Odia: "from-rose-500 to-orange-400",
    English: "from-indigo-500 to-purple-500",
    Mathematics: "from-blue-600 to-cyan-500",
    EVS: "from-emerald-500 to-lime-500",
    Science: "from-fuchsia-500 to-pink-500",
    "Social Science": "from-amber-500 to-yellow-500",
};

export function SubjectIcon({ subject, className = "h-5 w-5" }) {
    const Icon = ICONS[subject] || BookOpen;
    return <Icon className={className} />;
}

export function subjectGradient(subject) {
    return COLORS[subject] || "from-slate-500 to-slate-700";
}
